import { ADD_DOCUMENT, ADD_DOCUMENT_FAILED, ADD_DOCUMENT_SUCCESS, DOCUMENT, DOCUMENT_FAILED, DOCUMENT_SUCCESS, UPDATE_DOCUMENT, UPDATE_DOCUMENT_FAILED, UPDATE_DOCUMENT_SUCCESS } from "./actionTypes"

let initialState = {
    document: [],
    addDocument: "",
    updateDocument: "",
    loading: false,
    success: false,
    error: ''
}

export const documentReducer = (state = initialState, action) => {
    switch (action.type) {

        case DOCUMENT: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case DOCUMENT_SUCCESS: return {
            ...state,
            document: action.payload,
            loading: false,
            success: true
        }
        case DOCUMENT_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_DOCUMENT: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_DOCUMENT_SUCCESS: return {
            ...state,
            addDocument: action.payload,
            document: [...state.document, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_DOCUMENT_FAILED: return {
            ...state,
            addDocument: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_DOCUMENT: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_DOCUMENT_SUCCESS: return {
            ...state,
            updateDocument: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_DOCUMENT_FAILED: return {
            ...state,
            updateDocument: [],
            loading: false,
            success: false,
            error: action.payload
        }

        default: return state
    }
}